<div class="card light accounts-dashboard-table">
  <div class="light-content-panel-section">
    @if (accounts?.length) {
      <p-table
        #dt2
        [value]="accounts"
        [globalFilterFields]="['name', 'accountId', 'createdAt', 'entitlementExpiration']"
        dataKey="accountId"
        [scrollable]="true"
        [scrollHeight]="scrollHeight"
        [tableStyle]="{ 'min-width': '40rem' }"
        class="p-datatable-sm arp-accounts-dashboard-datatable"
        [rowHover]="true"
        [totalRecords]="accounts?.length ?? 0"
        overflow="auto"
        selectionMode="none"
        [rowTrackBy]="accountTrackBy"
      >
        <ng-template #caption>
          <div class="caption-container">
            <div class="panel-title">
              <h3>Select an {{ productName }} account to work with</h3>
            </div>
            <div class="flex-row">
              <span class="align-right flex-center-row">
                <p-iconfield class="filter-container">
                  <input
                    pInputText
                    #filterInput
                    type="text"
                    (input)="filterGlobal($event, dt2)"
                    placeholder="Filter..."
                  />
                  @if (!isFilterApplied) {
                    <p-inputicon class="fa-utility-fill fa-semibold fa-filter fade-icon" />
                  }
                  @if (isFilterApplied) {
                    <p-inputicon (click)="clear(dt2)" class="fa-utility fa-semibold fa-xmark" />
                  }
                </p-iconfield>
              </span>
            </div>
          </div>
        </ng-template>
        <ng-template #header>
          <tr>
            <th pSortableColumn="name" class="strong-text">Account Name <p-sort-icon field="name"></p-sort-icon></th>
            <th pSortableColumn="accountId" class="strong-text">
              Account ID <p-sort-icon field="accountId"></p-sort-icon>
            </th>
            <th pSortableColumn="createdAt" class="width-created-at-column strong-text">
              Created <p-sort-icon field="createdAt"></p-sort-icon>
            </th>
            <th pSortableColumn="entitlementExpiration" class="width-expire-column strong-text">
              Expiration <p-sort-icon field="entitlementExpiration"></p-sort-icon>
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-account>
          <tr>
            <td>
              <a class="navigate-href" [href]="account.accountId">
                {{ account.name }}
              </a>
            </td>
            <td>{{ account.accountId }}</td>
            <td>{{ account.createdAt | date: 'shortDate' }}</td>
            <td>
              @if (getExpired(account.entitlementExpiration) === true) {
                <p-tag
                  severity="warning"
                  [class]="'expired-badge'"
                  [value]="account.entitlementExpiration | date: 'shortDate' ?? 'Expired'"
                ></p-tag>
              }
              @if (getExpired(account.entitlementExpiration) === false) {
                <span [innerHtml]="account.entitlementExpiration | date: 'shortDate'"></span>
              }
            </td>
          </tr>
        </ng-template>
        <ng-template #summary>
          <div class="flex align-items-center justify-content-between">
            Displaying {{ dt2.filteredValue?.length ?? dt2.value.length }} of {{ dt2.value.length }} accounts.
          </div>
        </ng-template>
      </p-table>
    }
  </div>
</div>
